import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';

function Header() {
  return (
    <header className="header">
      <nav className="header-nav">
        <Link to="/">Home</Link>
      </nav>
    </header>
  );
}

export default Header;